import React, { useState } from 'react';
import './Contact.css';
import { api } from '../services/api';

const Contact = ({ onClose }) => {
  const [activeTab, setActiveTab] = useState('whatsapp');
  const [formData, setFormData] = useState({
    email: '',
    phone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const [successPopup, setSuccessPopup] = useState({ open: false, message: '' });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const nextValue = name === 'phone' ? value.replace(/\D/g, '').slice(0, 10) : value;
    setFormData({
      ...formData,
      [name]: nextValue
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitError('');
    setIsSubmitting(true);
    try {
      await api.sendQuery(formData);
      setSuccessPopup({ open: true, message: 'Message sent successfully!' });
      setFormData({ email: '', phone: '', message: '' }); // Form reset
    } catch (error) {
      setSuccessPopup({ open: true, message: error.message || 'Unable to send message.' });
      setSubmitError(error.message || 'Unable to send message.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleWhatsApp = () => {
    // Replace with your actual WhatsApp number
    const phoneNumber = '+917986427522';
    const message = 'Hello! I would like to know more about your events.';
    window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <div className="contact-overlay" onClick={onClose}>
      {successPopup.open && (
        <div
          className="contact-success-overlay"
          onClick={() => {
            setSuccessPopup({ open: false, message: '' });
            setSubmitError('');
          }}
        >
          <div className="contact-success-popup" onClick={(e) => e.stopPropagation()}>
            <h3>{submitError ? "Error" : "Success"}</h3>
            <p>{successPopup.message}</p>
            <button
              className="submitbtun"
              type="button"
              onClick={() => {
                setSuccessPopup({ open: false, message: '' });
                setSubmitError('');
                if (!submitError) {
                  onClose();
                }
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}
      <div className="contact-modal" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>×</button>
        
        <h2 className="modal-title">Reach out To Us</h2>
        
        <div className="tab-buttons">
          <button 
            className={`tab-btn ${activeTab === 'whatsapp' ? 'active' : ''}`}
            onClick={() => setActiveTab('whatsapp')}
          >
            Whatsapp
          </button>
          <button 
            className={`tab-btn ${activeTab === 'email' ? 'active' : ''}`}
            onClick={() => setActiveTab('email')}
          >
            EMAIL
          </button>
        </div>

        <div className="modalbody">
          {activeTab === 'email' ? (
          <form className="email-form" onSubmit={handleSubmit}>
            <input
              type="email"
              name="email"
              placeholder="Email"
              className="form-input"
              value={formData.email}
              onChange={handleInputChange}
              required
            />
            <input
              type="tel"
              name="phone"
              placeholder="Phone"
              className="form-input"
              value={formData.phone}
              onChange={handleInputChange}
              inputMode="numeric"
              maxLength={10}
              pattern="[0-9]{10}"
              required
            />
            <textarea
              name="message"
              placeholder="Message"
              className="form-input form-textarea"
              value={formData.message}
              onChange={handleInputChange}
              required
            />
            <button type="submit" className="submitbtun">
              {isSubmitting ? 'Sending...' : 'Send Message'}
            </button>
            {submitError && <p>{submitError}</p>}
          </form>
        ) : (
          <div className="whatsapp-content">
            <div className="whatsapp-icon">
              <img src={require('../assets/images/Whatsapp.png')} alt="WhatsApp" />
            </div>
            <p className="whatsapp-text">
              Start a conversation with us on whatsapp and<br />
              we reply in realtime
            </p>
            <button className="whatsapp-btn" onClick={handleWhatsApp}>
              Start Conversation
            </button>
          </div>
        )}
        </div>
      </div>
    </div>
  );
};

export default Contact;
